import router from '@/router'
window.tooptipsClick = (type, idx) => {

  sessionStorage.setItem('dataDetail', JSON.stringify(dataDetail[idx]))
  if (type === 4) {
    router.push(`/heart-detail-data`)
  } else {
    router.push(`/detail-data?deviceType=${type}`)
  }

}
window.dataDetail = null
